/* ============================================================
   Embedded Designz — Sticky Add to Cart Required-Field Guard
   File: assets/ed-sticky-atc-fix.js
   Loaded in theme.liquid AFTER theme.js, sitewide (all product pages).

   REVISION HISTORY (read before touching this again):
   - Pass 1 (2026-07-12): relayed the sticky button's click to
     form.querySelector('button[type="submit"]'), assuming that was
     Easify Options' real Add to Cart button and that a synthetic click
     would trigger its validation. FAILED — confirmed live via Chrome
     DevTools inspection that Easify replaces/renders its own button as
     <button class="tpo_add-to-cart" type="button">, NOT type="submit".
     The selector matched nothing, so the fix silently did nothing.
   - Pass 2 (2026-07-12): added form.reportValidity() as a hard gate.
     ALSO FAILED, for the same reason (still gated behind finding a
     nonexistent type="submit" button) — and even if that had been
     fixed, reportValidity() would have found nothing anyway: Easify's
     required fields are marked with a custom data-required="1"
     attribute, not the native HTML `required` attribute.
   - Pass 3 (2026-07-12, current, correct): live DOM inspection on the
     actual storefront revealed the real structure:
       1. Easify's option fields (.easify-product-options) are NOT
          inside the product <form> at all — confirmed via
          form.contains(easifyBlock) === false. They're rendered as a
          sibling block, with values read directly by Easify's own JS.
       2. Required fields are hidden <input type="text"> elements
          marked data-required="1" (Easify's own convention), whose
          .value is empty when unfilled.
       3. The sticky bar's button (outside the form, linked via the
          HTML5 form="" attribute) DOES still fire a native 'submit'
          event on the target form when clicked and not prevented —
          confirmed live by attaching a capturing document-level
          'submit' listener and clicking the sticky button.
       4. The common ancestor of the <form> and the sibling Easify
          block is div.product-info__block-list (confirmed via
          form.closest vs Easify block ancestor chain intersection).
     This fix intercepts that 'submit' event in the CAPTURING phase on
     document (fires before any listener on the form itself, regardless
     of script load order) and checks data-required="1" fields within
     the shared .product-info__block-list container — not just inside
     the <form> — since that's the only container that actually wraps
     both the form and Easify's sibling options block. Verified working
     live before shipping: blocked a real sticky-button submit attempt
     with Comfort Colors left empty.

   IMPORTANT GOTCHA (do not "simplify" this away): reading form.id as a
   property can silently return the wrong thing. Shopify's buy-buttons
   snippet includes <input type="hidden" name="id" value="...">, and
   HTML's named-form-control shadowing means form.id can resolve to
   THAT INPUT ELEMENT instead of the form's own id attribute in some
   browsers. Always read the id via form.getAttribute('id'), and always
   look up forms via document.getElementById(...) (unaffected by this),
   never via a bare .id property comparison.

   WHAT THIS DOES NOT TOUCH: the main product page's own Add to Cart
   button (Easify's .tpo_add-to-cart) never fires a native 'submit'
   event at all — it's type="button" and Easify handles validation +
   cart add entirely through its own click handler and fetch call. This
   script only engages for actual 'submit' events, so that already-
   working path is left completely alone.

   KNOWN REMAINING GAP — QUICK BUY: the quick-buy modal (product cards /
   "You may also like") clones product-info content from a <template>
   at open time. Confirmed live: .easify-product-options renders as a
   completely EMPTY container there (innerHTML length 0) — Easify's own
   script never initializes inside dynamically-cloned template content,
   so no fields, no data-required markers, nothing for this script (or
   Easify itself) to validate. This script still applies its
   .product-info__block-list-scoped guard to quick-buy's real <button
   type="submit">, so a quick-buy add currently proceeds with ZERO
   custom properties captured whenever the container has no required
   fields to find — which is indistinguishable, from this script alone,
   from "this product genuinely has no required options." This needs a
   separate fix (see snippets/ed-patch-notes.liquid FILE 13) —
   flagged, not yet addressed here.

   SCOPE: sitewide, all product templates, current and future — pure
   DOM behavior, no per-product/per-template configuration required.
   ============================================================ */

(function () {
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var formId = form && form.getAttribute ? form.getAttribute('id') : null;
      if (!formId || formId.indexOf('product-form') !== 0) return;

      var container = form.closest('.product-info__block-list') || form;
      var requiredFields = container.querySelectorAll('[data-required="1"]');

      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        var isEmpty =
          field.type === 'checkbox' || field.type === 'radio'
            ? !field.checked
            : !field.value || field.value.trim() === '';

        if (isEmpty) {
          event.preventDefault();
          event.stopPropagation();

          field.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // Nudge Easify's own inline validation UI, if any, in case it
          // listens for these events on its fields.
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          field.dispatchEvent(new Event('blur', { bubbles: true }));
          return;
        }
      }
    },
    true
  );
})();
